// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"11642018","126":"08340304","715":"92329ae3","792":"9142cc92","798":"99af95ac","812":"64153e9f","944":"0ca42981"}[chunkId] + ".chunk.css";
};